var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8a3 3 0 11-6 0 3 3 0 016 0zM6.61 8h2.78M8 9.39V6.61m11.7 9.646s-2.813-1.187-4.562.5c-1.75 1.688-4.032 3.97-7.188.812m11.185-8.736l-2.5-2.5-1.406 1.407 2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.229 7.739l-7.313 7.28v2.533h2.531l7.282-7.313z"
  }))));
}

export default SvgIconAddPath;